
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/detail",
      function () {
        return require("private-next-pages/detail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/detail"])
      });
    }
  